export const formatBytes = (size, decimal = 2) => {
  if (!+size) return '';
  const decimalCount = 0 > decimal ? 0 : decimal;
  const div = Math.floor(Math.log(size) / Math.log(1024));
  return `${parseFloat((size / Math.pow(1024, div)).toFixed(decimalCount))} ${
    ['Bytes', 'KB', 'MB'][div]
  }`;
};
